import { isHS } from './filterHost.js'
// 渠道账户一体化，判断主渠道后台没登录时的重定向地址
export const filterLoginPath = () => {
  // 恒实定制的
  if (isHS()) {
    return 'https://dqbg.crediths.com/channel-background/#/Login'
  }
  const currentHost = window.location.host
  var domain = 'wfq2020'
  if (currentHost.includes('ceecpj')) {
    domain = 'ceecpj'
  }

  const env = process.env.VUE_APP_ENV_TYPE
  const pathMap = {
    loc: `https://www-test.${domain}.com/channel-background/#/Login`,
    dev: `https://www-dev.local.${domain}.com/channel-background/#/Login`,
    test: `https://www-test.${domain}.com/channel-background/#/Login`,
    prod: `https://www.${domain}.com/channel-background/#/Login`,
  }
  return pathMap[env]
}
